import UsuarioRepository from '@/services/UsuarioRepository'

export default {
  namespaced: true,
  state: {
    nombreOperador: '',
    codigoAcceso: '',
    isUserSet: false,
    rol: []
  },
  mutations: {
    setUserName (state, [nombreOperador, codigoAcceso]) {
      state.nombreOperador = nombreOperador
      state.codigoAcceso = codigoAcceso

      localStorage.setItem('nombreOperador', nombreOperador)
    },

    setUser (state, [nombreOperador, codigoAcceso]) {
      state.nombreOperador = nombreOperador
      state.codigoAcceso = codigoAcceso
      state.isUserSet = true
    },

    setRol (state, [rol]) {
      state.rol = rol
    },

    // Called from restoreAuth action in auth
    restoreUserName (state) {
      state.nombreOperador = localStorage.getItem('nombreOperador')
    },

    unsetUser (state) {
      state.nombreOperador = ''
      state.codigoAcceso = ''
      state.isUserSet = false
      state.rol = []

      localStorage.removeItem('token')
      localStorage.removeItem('debeCambiarPin')
      localStorage.removeItem('nombreOperador')
    }
  },
  actions: {
    setUserName ({ commit }, [nombreOperador, codigoAcceso]) {
      commit('setUserName', [nombreOperador, codigoAcceso])
    },

    unsetUser ({ commit }) {
      commit('unsetUser')
    },

    async changeEmail (_, [correoElectronico]) {
      await UsuarioRepository.cambiarCorreoElectronico(correoElectronico)
    },

    async fetchRol ({ state, commit }) {
      if (state.rol.length > 0) {
        return
      }

      let resp = await UsuarioRepository.operadorRol()
      commit('setRol', [resp])
    },
  }
}
